module.exports = __webpack_public_path__ + "static/img/loading.3c44fafb.gif";